// import axios from "axios";

const response = [
  {
    id: 1,
    companyName: 'Company',
    companyLogo: '../img/logo-ipsum.svg',
    jobPosition: 'Web Developer',
    city: 'Sofia',
    country: 'Bulgaria',
    employmentType: ['Employment'],
    startDate: '2019-05-07',
    tags: ['.net', 'css', 'mvc', 'html'],
  },
  {
    id: 2,
    companyName: 'Company',
    companyLogo: '../img/logo-ipsum2.svg',
    jobPosition: 'Full Stack Dev',
    city: 'Sofia',
    country: 'Bulgaria',
    employmentType: ['Self-employment'],
    startDate: '2019-05-07',
    tags: ['nodejs', 'js', 'vuejs'],
  },
  {
    id: 3,
    companyLogo: '../img/logo-ipsum3.svg',
    companyName: 'Jobshark',
    jobPosition: 'Python Programmer',
    city: 'Sofia',
    country: 'Bulgaria',
    employmentType: ['Employment'],
    startDate: '2019-05-07',
    tags: ['django', 'python'],
  },
  {
    id: 4,
    companyLogo: '../img/logo-ipsum.svg',
    companyName: 'Jobshark',
    jobPosition: 'Javascript developer',
    city: 'Sofia',
    country: 'Bulgaria',
    employmentType: ['Employment'],
    startDate: '2019-05-07',
    tags: ['ruby', 'django', 'python'],
  },
  {
    id: 5,
    companyLogo: '../img/logo-ipsum2.svg',
    companyName: 'Jobshark',
    jobPosition: 'Team Lead',
    city: 'Sofia',
    country: 'Bulgaria',
    employmentType: ['Employment'],
    startDate: '2019-05-07',
    tags: ['ruby', 'django', 'python'],
  },
];

const state = {
  searchJobResults: [],
  singleJobResult: null,
};

const getters = {
  allSearchJobResults: state => state.searchJobResults,
  singleJob: state => state.singleJobResult,
};

const actions = {
  async fetchAllJobResults({ commit }) {
    commit('setSearchJobResults', response);
  },
  async fetchSingleJobResult({ commit }, _id) {
    let singleJob = response.find(job => job.id === _id);

    commit('setFetchSingleJobResult', singleJob);
  },
};

const mutations = {
  setSearchJobResults: (state, searchJobResults) => (state.searchJobResults = searchJobResults),
  setFetchSingleJobResult: (state, singleJobResult) => (state.singleJobResult = singleJobResult),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
